module.exports = __webpack_public_path__ + "static/media/catWalk.80efc2a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/catWalk.gif
// module id = 161
// module chunks = 0